import { render } from "./TopHeadEnglish.vue?vue&type=template&id=5e61674a&scoped=true&ts=true"
import script from "./TopHeadEnglish.vue?vue&type=script&lang=ts"
export * from "./TopHeadEnglish.vue?vue&type=script&lang=ts"

import "./TopHeadEnglish.vue?vue&type=style&index=0&id=5e61674a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e61674a"]])

export default __exports__